import { VulnerabilityType } from './product';

export enum RequestType {
  monoLight = 'mono-luce',
  monoGas = 'mono-gas',
  dual = 'dual',
}

export enum AutoricaricaType {
  activation = 'COOP Autocharge activation',
  deactivation = 'COOP Autocharge deactivation',
}

export enum Status {
  ko = 'KO',
  ok = 'OK',
}

export enum DocsReceptionRequestType {
  registration = 'registration',
  update = 'update',
  delete = 'delete',
}


export enum SupplyInvoiceReceptionRequestType {
  email2Email = 'email2email',
  physical2physical = 'physical2physical',
  email2physical = 'email2physical',
  physical2email = 'physical2email',
  changeLayout = 'changeLayout',
}

export enum SupplyInvoiceReceptionLayout {
  analitica = 'Analitica',
  sintetica = 'Sintetica',
}

export enum SupplyInvoiceReceptionDeliveryMode {
  email = 'Email',
  physical = 'Posta',
}

export enum PaymentMethodRequestType {
  bollettino = 'Bollettino',
  libretto = 'Libretto',
  sepa = 'Rid',
}

export interface Fisso {
  idRichiesta: string;
  contractId: string;
  temporaryUrl: string;
  clientPod: string;
  clientPdr: string;
  email: string;
  clientCF: string;
  isLight: boolean;
  isGas: boolean;
  isDual: boolean;
  firstNameAndSurname: string;
  dataCTE: string;
  phone_number: string;
  monthOfCTE: string;
  yearOfCTE: number;
  tariffa: string;
  duration: string;
  contractType: string;
  requestType: RequestType;
  stato: Status;
  cteLink: string;
  cgfLink: string;
  monorarioBiorarioPWR: string;
  durataPWR: string;
  durataGAS: string;
  DataDecorrenza: string;
}

export interface UserInfo {
  FirstName: string;
  LastName: string;
  fiscalCode: string;
}

export interface CambioPiano {
  requestId: string;
  requestCode: string;
  temporaryUrl: string;
  POD: string;
  PDR: string;
  email: string;
  fiscalCode: string;
  isLight: boolean;
  isGas: boolean;
  isDual: boolean;
  FirstName: string;
  LastName: string;
  dataCTE: string;
  phone: string;
  monthOfCTE: string;
  yearOfCTE: number;
  tariffa: string;
  durata: string;
  contractType: string;
  requestType: RequestType;
  cteLink: string;
  cgfLink: string;
  monorarioBiorarioPWR: string;
  durataPWR: string;
  durataGAS: string;
  DataDecorrenza: string;
  canaleProvenienza: string;
  NewProductName: string;
  priceType: string;
  greenEnergy: boolean;
  otpValidateRequest: boolean;
  vulnerabilityType: VulnerabilityType;
  vulnerabilityType104Disability: boolean;
  billingFrequency: string;
}
export interface RicezioneDocumenti {
  requestId: string;
  requestCode: string;
  oldPec: string;
  oldEmail: string;
  email: string;
  pec: string;
  address: string;
  modifiedAsset: string;
  phone: string;
  customerCode: string;
  fiscalCode: string;
  FirstName: string;
  LastName: string;
  requestType: DocsReceptionRequestType;
}

export interface RicezioneFattureFornitura {
  requestId: string;
  requestCode: string;
  oldPec: string;
  oldEmail: string;
  email: string;
  pec: string;
  address: string;
  oldAddress: string;
  modifiedAsset: string;
  phone: string;
  customerCode: string;
  fiscalCode: string;
  FirstName: string;
  LastName: string;
  oldLayout: SupplyInvoiceReceptionLayout;
  layout: SupplyInvoiceReceptionLayout;
  oldDeliveryMode: SupplyInvoiceReceptionDeliveryMode;
  deliveryMode: SupplyInvoiceReceptionDeliveryMode;
  oldFromPec: boolean;
  fromPec: boolean;
}

export interface ModalitaPagamento {
  requestId: string;
  requestCode: string;
  email: string;
  pec: string;
  address: string;
  modifiedAsset: string;
  phone: string;
  customerCode: string;
  fiscalCode: string;
  FirstName: string;
  LastName: string;
  paymentMethod: PaymentMethodRequestType;
  bookletNumber: string;
  iban: string;
  sepaBank: string;
  thirdPartyIbanHolder: string;
  subscriberFullName: string;
  subscriberTaxCode: string;
  oldPaymentMethod: PaymentMethodRequestType;
  oldBookletNumber: string;
  oldIban: string;
  oldThirdPartyIbanHolder: string;
  oldSubscriberFullName: string;
  oldSubscriberTaxCode: string;
  requestType: RequestType;
  coopCode: string;
}

export interface UserInfo {
  FirstName: string;
  LastName: string;
  fiscalCode: string;
}

export interface Autoricarica {
  requestId: string;
  codeRequest: string;
  temporaryUrl: string;
  email: string;
  fiscalCode: string;
  FirstName: string;
  LastName: string;
  phone: string;
  typeRequest: AutoricaricaType;
  coopMemberCard: string;
  otpValidateRequest: boolean;
  gasFieldSupplies: [''];
  lightFieldSupplies: [''];
  Alg_OTPCheck__c: boolean;
  Alg_OTPCheckDate__c: string;
}



// WEBPACK FOOTER //
// ./src/app/models/fisso.ts